<div class="container-fluid">
  <div class="search-wrapper mat-elevation-z2">
<!-- [columns]="columns" -->


    <div class="search" >
      <mat-icon [ngClass]="{'animate' : true }">search</mat-icon>
      <input type="text" [(ngModel)]="kwSearch" [value]="kwSearch" (ngModelChange)="search($event)"
      [placeholder]="translate.instant('LABEL.SEARCH')" />
    </div>
  </div>
  <div style="overflow-x: auto;">
  <table mat-table [dataSource]="dataSource" matSort style="width:100%;">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="back-table centered">{{ 'LABEL.ID' | translate }}</th>
      <td class="tdg" mat-cell *matCellDef="let element" style="padding: 0; width: auto; padding-left: 1%;">
        {{element.id}} </td>
    </ng-container>
    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="back-table centered">{{ 'ACTIVITIES.OWNER' | translate }}</th>
      <td class="tdg" mat-cell *matCellDef="let element" style="padding: 0; width: auto; "> <span><b>{{element.owner}}</b></span>
      </td>
    </ng-container>
    <ng-container matColumnDef="activityDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="back-table centered">{{ 'ACTIVITIES.DATE' | translate }}</th>
      <td class="tdg" mat-cell *matCellDef="let element" style="padding: 0; width: auto; "> <span>{{element.activityDate | date: 'dd/MM/yyyy'}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="back-table centered">{{ 'ACTIVITIES.ACTIVITY' | translate }}</th>
      <td class="tdg" mat-cell *matCellDef="let element" style="padding: 0; width: auto; "> <span><b>{{'ACTIVITIES.'+element.type | translate }}</b></span></td>
    </ng-container>
    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="back-table centered">{{ 'ACTIVITIES.SUBJ' | translate }}</th>
      <td *matCellDef="let element" class="tdg" mat-cell style="padding: 0;width: auto; "><span *ngIf="(element.subject !== null)"> {{element.subject.name + " " + element?.subject?.surname}}</span></td>
    </ng-container>
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="back-table centered">{{ 'ACTIVITIES.NOTE' | translate }}</th>
      <td class="tdg" mat-cell *matCellDef="let element" style="padding: 0; width: auto; "> <span *ngIf="!(element.notes == null)">{{element.notes}}</span>
        <span *ngIf="(element.notes == null)"><i class="material-icons icsave">warning</i></span></td>
    </ng-container>

    <ng-container matColumnDef="editAction" >
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" (click)="goTo(element)"><i class="material-icons icsave" *ngIf="(toDisable === false)">edit</i></td>
    </ng-container>
    <ng-container matColumnDef="deleteAction">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" (click)="deleteRow(element)"><i class="material-icons icsave">delete</i></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="back-table centered"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
  <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[10, 20, 30]">
  </mat-paginator>

  <div>
    <br>
    <br>
    <button *ngIf="this.subject" (click)="createActivity()" style="float: right;" mat-button color="primary" [disabled]="toDisable">{{ 'ACTIVITIES.CREATE' | translate }}</button>
  </div>
</div>
